"use client"

import type { PromotionItem as PromotionItemType } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/types/config"
import { t } from "@/languages/i18n"
import { toImageSrc } from "@/lib/utils"
import Link from "next/link"

interface PromotionItemProps {
  promotion: PromotionItemType
  onClick: () => void
  isActive: boolean
}

// Chấp nhận link có hoặc không có "/" đầu (quen flow cũ): "/en/guarana-en" hay "en/guarana-en".
// Giữ nguyên link ngoài (http), anchor, mailto/tel.
const normalizeButtonLink = (link?: string): string => {
  const trimmed = (link || "").trim()
  if (!trimmed || trimmed === "#") return "#"
  if (/^(https?:)?\/\//.test(trimmed) || /^(mailto:|tel:)/.test(trimmed) || trimmed.startsWith("#")) {
    return trimmed
  }
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`
}

export const PromotionItem: React.FC<PromotionItemProps> = ({ promotion, onClick, isActive }) => {
  const insideBackgroundImageUrl = promotion.insideBackgroundImage ? toImageSrc(promotion.insideBackgroundImage) : null
  const buttonHref = normalizeButtonLink(promotion.buttonLink)
  const buttonText = promotion.buttonText?.trim() || t("Join now")

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer relative flex items-center justify-center flex-col rounded-lg w-[243px] h-[342px]"
      style={{
        background: insideBackgroundImageUrl
          ? `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(${insideBackgroundImageUrl})`
          : "linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0))",
        fill: "both",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "drop-shadow(0 0 rgba(0, 0, 0, 0.3))",
      }}
    >
      {/* Hover/Active Overlay */}
      <div
        className={`absolute inset-0 rounded-lg transition-all duration-300 ease-in field-activity-overlay opacity-0  group-hover:opacity-90  ${isActive ? "!opacity-90" : ""}`
        }
      />
      {/* Content */}
      <div className="relative h-full w-full flex flex-col items-center justify-center text-center z-10 scale-100 group-hover:animate-[zoom_0.3s_ease-in_forwards]">
        {/* Title */}
        <h3 className="text-white text-base sm:leading-6 leading-[26px] font-black uppercase">
          {promotion.title}
        </h3>

        <div
          className="relative mt-2"
          onClick={(e) => e.stopPropagation()}
        >
          <Link
            href={buttonHref}
            className="text-sm font-bold text-white hover:text-white border border-white rounded py-2 px-6 transition duration-300 ease-in-out bg-transparent btn-zoom-effect"
          >
            {buttonText}
          </Link>
        </div>
      </div>
    </div>
  )
}

